import rules from './rules';

export default function*(){
    yield* [...rules];
}